// capitalize first letter of a word
export function capitalize(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

// extract tags from string
export function extractTags(value: string): [string, string] {
    const tags: string[] = [];
    let tag = "";
    let query = "";
    let index = 0;
    let insideTag = false;
    while (index < value.length) {
        if (insideTag) {
            if (value[index] === "]") {
                if (tag) {
                    // remove invalid chars from tag
                    tag.replace(/\s[|&;$%@"<>()+,]/g, "");
                    tags.push(tag);
                    tag = "";
                }
                insideTag = false;
            } else {
                tag += value[index];
            }
        } else if (value[index] === "[") {
            insideTag = true;
        } else {
            query += value[index];
        }
        index++;
    }

    query += tag;

    return [tags.join(","), query];
}

// helper functions to format view count
export function formatViews(views: number): string {
    const postfix: string[] = ["", "k", "M", "B"];
    let index: number = 0;
    while (views >= 1000) {
        views = Math.floor(views / 1000);
        index++;
    }
    return String(views) + postfix[index];
}

// get id parameter from url
import { useParams } from "react-router-dom";

export function getIdParam(): number {
    const { id } = useParams();
    if (id) {
        return +id;
    } else {
        return -1;
    }
}

// truncate text
export function truncateText(text: string, length: number): string {
    return text.length > length ? text.slice(0, length) + "..." : text;
}
